import { IconProps } from './Icon.types';

export const Check = ({
  size = 24,
  fill = '#000',
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      width="24"
      height="24"
    />
    <path
      d="M9.55004 17.3073L4.58081 12.3381L5.29426 11.6246L9.55004 15.8804L18.7058 6.72461L19.4193 7.43806L9.55004 17.3073Z"
      fill={fill}
    />
  </svg>
);

